import { FETCH_EQUIPMENT } from '../actionTypes';

const initialState = null;

export default function(state = initialState, action=null){
  if (action.type === FETCH_EQUIPMENT) {
    return {...state, ...action.payload};
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/equipment.js